import {
  VuetifyTiptap,
  VuetifyViewer,
  createVuetifyProTipTap,
  BaseKit,
  Bold,
  Italic,
  Underline,
  Strike,
  FontSize,
  BulletList,
  OrderedList,
  Link,
  Blockquote,
  HorizontalRule,
  History,
  Heading,
} from "vuetify-pro-tiptap";
import "vuetify-pro-tiptap/style.css";

export const vuetifyProTipTap = createVuetifyProTipTap({
  lang: "en",
  components: {
    VuetifyTiptap,
    VuetifyViewer,
  },
  extensions: [
    History,
    Heading,
    BaseKit.configure({
      placeholder: {
        placeholder: "",
      },
    }),
    Bold,
    Italic,
    Underline,
    Strike,
    FontSize,
    BulletList,
    OrderedList,
    Link,
    Blockquote,
    HorizontalRule,
  ],
});
